<template>
    <div style="width:100%">
        <div id="Dashboard-middle"></div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            EchartMiddleOption:{},
            demoDataObj:{
            name: '工程进度',
            unit: '%',
            value: 72,
            },
            demoData:[{
            name: '工程进度',
            unit: '%',
            value: 72,
        }],
        timer:null,

        }
    },
    mounted(){
         this.getEchartMiddle()
        this.timer = setInterval(this.echartMove, 5000);
        // this.getEchartMiddle()

    },
    methods:{
        echartMove(){
      setTimeout(() => {
          console.log("多久",this.demoDataObj.value)
          if(this.demoDataObj.value==0){
              this.demoDataObj.value=72
            this.demoData=[{
                name: '工程进度',
                unit: '%',
                value: 72,
            }]
          }else{
               this.demoDataObj.value=0
            this.demoData=[{
                name: '工程进度',
                unit: '%',
                value: 0,
            }]
          }

          this.getEchartMiddle()
      }, 10000);
        },
        getEchartMiddle(){
        let that = this;
        var myChart = that.$echarts.init(document.getElementById('Dashboard-middle'));
        var demoData = this.demoData
        let option = {
                            animation: true,
animationDuration: 3000,
            grid: {
                bottom: "8%"
            },
            // backgroundColor: '#010101',
            series: (function() {
                var result = [];
                demoData.forEach(function(item) {
                    result.push(
                        {
                             // 绿色半圆第一环
                        name: item.name,
                        type: 'gauge',
                        radius: '88.10%',
                        startAngle: 225,
                        endAngle: -45,
                        min: 0,
                        max: 100,
                        axisLine: {
                            show: true,
                            lineStyle: {
                                width: 6,
                                shadowBlur: 10,
                                color: [
                                    // 最外圈颜色
                                    [1, 'rgb(29,154,255)']
                            // [0, 'transparent'],
                            // [0.1, 'rgb(29,154,255)'],
                            // [0.101, 'transparent'],
                            // [0.2, 'rgb(29,154,255)'],
                            // [0.201, 'transparent'],
                            // [0.3, 'rgb(29,154,255)'],
                            // [0.301, 'transparent'],
                            // [0.4, 'rgb(29,154,255)'],
                            // [0.401, 'transparent'],
                            // [0.5, 'rgb(29,154,255)'],
                            // [0.501, 'transparent'],
                            // [0.6, 'rgb(29,154,255)'],
                            // [0.601, 'transparent'],
                            // [0.7, 'rgb(29,154,255)'],
                            // [0.701, 'transparent'],
                            // [0.8, 'rgb(29,154,255)'],
                            // [0.801, 'transparent'],
                            // [0.9, 'rgb(29,154,255)'],
                            // [0.901, 'transparent'],
                            // [1, 'rgb(29,154,255)']
                        ],
                            }
                        },
                        axisTick: {
                            show: 0,
                        },
                        splitLine: {
                            show: 0,
                        },
                        axisLabel: {
                            show: 0
                        },
                        pointer: {
                            show: false,
                        },
                        detail: {
                            show: false,
                        },
                        data: [{
                            show: false,
                        }]},
                    {//指针内环
                        "type": 'pie',
                        "hoverAnimation": false,
                        "legendHoverLink": false,
                        "radius": ['39%', '43%'],
                        // "z": 10,
                        "label": {
                            "normal": {
                                "show": false
                            }
                        },
                        "labelLine": {
                            "normal": {
                                "show": false
                            }
                        },
                        "data": [{
                            "value": 100,
                            itemStyle: {
                                normal: {
                                    color: "rgb(0,94,255)"
                                }
                            }
                        }]
                    },
            // {//遮盖指针
            //     "type": 'pie',
            //     "hoverAnimation": false,
            //     "legendHoverLink": false,
            //     "radius": ['0%', '20%'],
            //     "z": 10,
            //     data: [{
            //         name: '污染程度',
            //         value: '80',
            //         itemStyle: {
            //             normal: {
            //                 color: new that.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
            //                     offset: 0,
            //                     color: '#4FADFD'
            //                 }, {
            //                     offset: 1,
            //                     color: '#28E8FA'
            //                 }])
            //             }

            //         },
            //         label: {
            //             normal: {
            //                 rich: {
            //                     a: {
            //                         // color: '#468EFD',
            //                          color: '#fff',
            //                         align: 'center',
            //                         fontSize: 32,
            //                         fontWeight: "bold"
            //                     },
            //                 },
            //                 formatter: function (params) {
            //                     return "{a|" + item.value+'%' + "}";
            //                 },
            //                 position: 'center',
            //                 show: true
            //             }
            //         },
            //         labelLine: {
            //             show: false
            //         }
            //     }],
            // },


                {
                    name: "最外部宽线条",
                    type: "gauge",
                    radius: '98%',
                    startAngle: 225,
                    endAngle: -45,
            //                    animationEasing: "linear",
            //   animationEasingUpdate: "quadraticIn",  //数据更新时的缓动效果
            //   animationDurationUpdate: 1000,  //数据更新动画的时长
            //   animation: true,  //开启动画
                        axisLine: {
                            show: true,
                            lineStyle: {
                                width: 5,
                                color: [
                                    [
                                        // 指针光带渐变rgba(0,85,255,0)
                                        1, new that.$echarts.graphic.LinearGradient(
                                            0, 1, 1, 1, [{
                                                    offset: 0,
                                                    color: 'rgba(0,85,255,1)',
                                                }, {
                                                    offset: 0.3,
                                                    color: 'rgba(0,85,255,0)',
                                                },
                                                {
                                                    offset: 0.7,
                                                    color: 'rgba(0,85,255,0)',
                                                },
                                                {
                                                    offset: 1,
                                                    color: 'rgba(0,85,255,1)',
                                                }
                                            ]
                                        )
                                    ],
                                    [
                                        1, 'rgba(255,255,255,.0)'
                                    ]
                                ],
                            }
                        },
                    axisLabel: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                    splitLine: {
                        show: false,
                    },
                    detail: {
                        show: false
                    },
                    title: {
                        show: false,
                    }
                },
                {
                    name: "内部宽线条",
                    type: "gauge",
                    radius: '78%',
                    startAngle: 225,
                    endAngle: -45,
                    axisLine: {
                        lineStyle: {
                            color: [
                                [1, 'rgb(0,85,255)']
                            ],
                            width: 7
                        }
                    },
                    axisLabel: {
                        show: false,
                    },
                    axisTick: {
                        show: false,
                    },
                    splitLine: {
                        show: false,
                    },
                    detail: {
                        show: false
                    },
                    title: {
                        show: false,
                    }
                },
                        {
                        name: item.name,
                        type: 'gauge',
                        radius: '82%',
                        startAngle: 225,
                        endAngle: -45,
                        // "z": 9,
                        min: 0,
                        max: 100,
                        axisLine: {
                            show: true,
                            lineStyle: {
                                width: 60,
                                color: [
                                    [
                                        // 指针光带渐变rgba(0,85,255,0)
                                        item.value / 100, new that.$echarts.graphic.LinearGradient(
                                            0, 1, 1, 0, [{
                                                    offset: 0,
                                                    color: 'rgba(18,181,127,0)',
                                                }, {
                                                    offset: 0.3,
                                                    color: 'rgba(18,181,127,0.3)',
                                                },
                                                {
                                                    offset: 1,
                                                    color: 'rgba(18,181,127,1)',
                                                }
                                            ]
                                        )
                                    ],
                                    [
                                        1, 'rgba(255,255,255,.0)'
                                    ]
                                ],
                            }
                        },
                        axisTick: {
                            show: 0,
                        },
                        splitLine: {
                            show: 0,
                        },
                        axisLabel: {
                            show: 0
                        },
                        // pointer: {
                        //     show: true,
                        //     length: '100%'
                        // },
                        detail: {
                            show: true,
                            offsetCenter: [0, '55%'],
                            textStyle: {
                                // 最终数值样式
                                fontSize: 32,
                                color: '#fff',
                                // offsetCenter: [0,'80%']
                            },
                            formatter: [
                                '{value}' + (item.unit || ''),
                                '{name|' + item.name + '}'
                            ].join('\n'),
                            rich: {
                                name: {
                                    // 标题样式
                                    fontSize: 20,
                                    lineHeight: 120,
                                    color: '#fff',
                                    fontWeight: '600',
                                    // offsetCenter: ["0", "53%"]
                                
                                },
                                
                            }
                        },
                        itemStyle: {
                            color: 'rgb(0,230,253)',//指针边框颜色
                            borderColor: 'rgb(0,230,253)',//指针填充背景颜色
                        },
                    pointer: {
                        show: true,
                        length: '48%',
                        // radius: '20%',
                        width: 5, //指针粗细
                        // offsetCenter:[-50,373],
                        offsetCenter: [0, -70]
                    },
                        data: [{
                            value: item.value
                        }]}, 
                        {
                        type: 'gauge',
                        radius: '86%',
                        splitNumber: 10,
                        min: 0,
                        max: 100,
                        startAngle: 225,
                        endAngle: -45,
                        axisLine: {
                            show: true,
                            lineStyle: {
                                width: 7,
                                color: [
                                    [1,
                                        new that.$echarts.graphic.LinearGradient(0, 0, 1, 0, [
                                            // 刻度边颜色yellow
                                            {
                                                offset: 0,
                                                color: 'rgb(0,85,255)'
                                            },
                                            {
                                                offset: 1,
                                                color: 'rgb(0,85,255)'
                                            }
                                        ])
                                    ]
                                ],
                            }
                        },
                        axisLabel: {
                            distance: 6,
                            textStyle: {
                                // 整数刻度线颜色 0 10 20....
                                color: '#fff',
                                fontSize: '14'
                            }
                        },
                        splitLine: {
                            show: true,
                            length: 16,
                            lineStyle: {
                                // 整数刻度数字颜色 0 10 20....
                                color: "#fff",
                            }
                        },
                        // detail: {
                        //     show: 0
                        // }
                    }, );
                });

                return result;
            })()
        };
                //此处使用定时器setInterval循环刷新柱状图的值,每次刷新数据均不同
        // setInterval(() => {
        //   for (let i = 0; i <= this.demoDataObj.value; i++) {  //定义i确保柱图的每一项都能被刷新
        //    this.demoData=[{
        //     name: '工程进度',
        //     unit: '%',
        //     value: i,
        // }]
        //   }
        //    var myChart = that.$echarts.init(document.getElementById('Dashboard-middle'));
        //   myEchart.setOption(option, true); //每刷新一次重新显示图表
        // }, 1000);
        option && myChart.setOption(option);
        window.onresize = function(){
            myChart.resize();
        }
        }

    },
    
}
</script>
<style lang="less" scoped>
#Dashboard-middle{
    width: 100%;
    height: 285px;

}

</style>


// WEBPACK FOOTER //
// src/components/cockpitCh/echarts/DashboardMiddle.vue